// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-D0870D0F-FC01-40C4-B9A8-686966C8FB90 > .combo {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://src/uicomponents/components/exactTime/exactTime.less"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":["#V-D0870D0F-FC01-40C4-B9A8-686966C8FB90{\n    &>.combo{\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
